// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AdvisorRerunIn } from './advisorRerunIn.zod.ts';

export const AdvisorRunRerunApiAdvisorRunsRunIdRerunPostBody = zod.union([AdvisorRerunIn,zod.null()])

export type AdvisorRunRerunApiAdvisorRunsRunIdRerunPostBody = zod.input<typeof AdvisorRunRerunApiAdvisorRunsRunIdRerunPostBody>;
export type AdvisorRunRerunApiAdvisorRunsRunIdRerunPostBodyOutput = zod.output<typeof AdvisorRunRerunApiAdvisorRunsRunIdRerunPostBody>;
